import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["checkbox", "item", "list"];

  connect() {
    this.filterItems();
  }

  toggleFilter(event) {
    this.filterItems();
  }

  filterItems() {
    const showAll = this.checkboxTarget.checked;

    // Make list scrollable when showing all tools
    if (showAll) {
      this.listTarget.style.maxHeight = "400px";
      this.listTarget.style.overflowY = "auto";
      this.listTarget.classList.add("rating-tools-scrollable");
    } else {
      this.listTarget.style.maxHeight = "";
      this.listTarget.style.overflowY = "";
      this.listTarget.classList.remove("rating-tools-scrollable");
    }

    this.itemTargets.forEach((item) => {
      const isGeneral = item.dataset.isGeneral === "true";
      const isSelected = item.dataset.isSelected === "true";

      // Show if: (general) OR (selected) OR (showAll toggle is on)
      if (isGeneral || isSelected || showAll) {
        item.style.display = "";
      } else {
        item.style.display = "none";
      }
    });
  }
}
